import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "p-inputgroup" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "p-m-0" }
const _hoisted_4 = {
  key: 0,
  style: {"color":"orange"}
}
const _hoisted_5 = ["for"]

import { computed, defineAsyncComponent, ref } from "vue";
import { useActivityResponsible } from "@/graphql/responsible/activity.responsible";
import { useRemoveResponsible } from "@/graphql/responsible/remove.responsible";
import { useWHoAmI } from "@/graphql/user/whoAmi";
import { getImage } from "@/graphql/utils/utils";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { useChangeResponsibleRole } from "@/graphql/responsible/change-responsible-role";
import { useRoles } from "@/hooks/role/useRoles";
import { useI18n } from "vue-i18n";
import { EAccessMenu, Responsible } from "@/graphql/types";
import { canNavigateAnywhere, getAccess } from "@/utils/activity";


export default /*#__PURE__*/_defineComponent({
  __name: 'Responsible',
  setup(__props) {

const InviteResponsible = defineAsyncComponent(
  () => import("@/components/responsible/InviteResponsible.vue")
);

const FILTER = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  roleId: {
    operator: FilterOperator.AND,
    constraints: [{ value: [], matchMode: FilterMatchMode.IN }],
  },
};

const { t } = useI18n();
const filters = ref(FILTER);
const { roles } = useRoles();
const { Iam } = useWHoAmI();
const { removeLoading, submitRemove } = useRemoveResponsible();
const { loadResponsible, responsible } = useActivityResponsible();
const { loadingChange, changeRole, openChangeRole, changeRoleForm } =
  useChangeResponsibleRole();
const cmd = (value: number) =>
  (filters.value.roleId.constraints[0].value = value != -1 ? [value] : []);
const rolesSplit = computed(() => {
  const _roles = roles.value.map(({ id, name }) => ({
    label: name,
    command: () => cmd(id),
    value: id,
  }));

  return [
    {
      label: t("activity.all"),
      command: () => cmd(-1),
      value: -1,
    },
    {
      label: t("activity.owner"),
      command: () => cmd(null),
      value: null,
    },
    ..._roles,
  ];
});
const canUpdate = computed(() => {
  const acc = getAccess(EAccessMenu.Activity);
  const noRestriction = canNavigateAnywhere();
  return acc?.update || noRestriction;
});

const canEditRole = (data: Responsible) => {
  return canUpdate.value && Iam.value?.id !== data.user.id && !!data.roleId;
};

const getRole = (id?: number) => {
  if (!id) {
    return t("activity.owner");
  }
  const role = rolesSplit.value.find((role) => role.value === id);
  return role?.label || "";
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (canUpdate.value)
      ? (_openBlock(), _createBlock(_unref(InviteResponsible), { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_DataTable, {
      style: {"width":"100%","height":"100%"},
      value: [..._unref(responsible)],
      dataKey: "id",
      responsiveLayout: "scroll",
      loading: _unref(loadResponsible),
      rows: 5,
      class: "p-datatable-sm",
      filters: filters.value,
      "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((filters).value = $event)),
      globalFilterFields: ['user.name', 'user.email'],
      paginator: true,
      "always-show-paginator": false
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_InputText, {
            modelValue: filters.value.global.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.global.value) = $event)),
            placeholder: _ctx.$t('responsible.placeholder')
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_SplitButton, {
            label: "Type",
            model: rolesSplit.value
          }, null, 8, ["model"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, null, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("responsible.collaborators")), 1)
          ]),
          body: _withCtx(({ data }) => [
            _createVNode(_component_Avatar, {
              image: _unref(getImage)(data.user.image, 'users'),
              shape: "circle"
            }, null, 8, ["image"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { "filter-field": "roleId" }, {
          body: _withCtx(({ data }) => [
            (_unref(Iam)?.id !== data.user.id)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", null, _toDisplayString(data.user.name), 1),
                  _createElementVNode("div", null, _toDisplayString(data.user.email), 1)
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("you")), 1)),
            _createElementVNode("span", null, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(getRole(data.roleId)), 1),
              (!data.accepted)
                ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t("responsible.pending")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { style: {"width":"30px"} }, {
          body: _withCtx(({ data }) => [
            (canEditRole(data))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_Button, {
                    icon: "pi pi-trash",
                    loading: _unref(removeLoading),
                    class: "p-button-rounded p-button-secondary p-button-text",
                    onClick: ($event: any) => (_unref(submitRemove)($event, data.id, _unref(Iam)?.id === data.user.id))
                  }, null, 8, ["loading", "onClick"]),
                  _createVNode(_component_Button, {
                    icon: "pi pi-pencil",
                    class: _normalizeClass(["p-button-rounded p-button-text", { 'p-button-success': data.id === _unref(changeRoleForm).id }]),
                    onClick: ($event: any) => (_unref(openChangeRole)(data))
                  }, null, 8, ["class", "onClick"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "loading", "filters"]),
    _createVNode(_component_Dialog, {
      closable: "",
      visible: _unref(changeRoleForm).visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_unref(changeRoleForm).visible) = $event)),
      header: _ctx.$t('responsible.newRole', { name: _unref(changeRoleForm).name })
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          disabled: _unref(loadingChange),
          loading: _unref(loadingChange),
          onClick: _unref(changeRole),
          label: _ctx.$t('modify')
        }, null, 8, ["disabled", "loading", "onClick", "label"])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(roles), (rl, index) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "p-field-radiobutton",
            key: index
          }, [
            _createVNode(_component_RadioButton, {
              modelValue: _unref(changeRoleForm).role,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(changeRoleForm).role) = $event)),
              value: rl.id,
              name: "role",
              id: 'role' + index
            }, null, 8, ["modelValue", "value", "id"]),
            _createElementVNode("label", {
              for: 'role' + index
            }, _toDisplayString(rl.name), 9, _hoisted_5)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}
}

})